import { render, staticRenderFns } from "./CardShipping.vue?vue&type=template&id=284905ea&scoped=true"
import script from "./CardShipping.vue?vue&type=script&lang=js"
export * from "./CardShipping.vue?vue&type=script&lang=js"
import style0 from "./CardShipping.vue?vue&type=style&index=0&id=284905ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284905ea",
  null
  
)

export default component.exports